import { render } from "./CsvDownloader.vue?vue&type=template&id=e840a3cc"
import script from "./CsvDownloader.vue?vue&type=script&lang=ts"
export * from "./CsvDownloader.vue?vue&type=script&lang=ts"
script.render = render

export default script